/**
 * ERP 배너 컴포넌트
 * @returns JSX.Element
 */
const ErpBanner = () => {
	return (
		<section className="main-erp main-section">
			<div className="main-erp-inner">
				<div className="title-group">
					<p className="title">왜 Stella ERP인가?</p>
				</div>
				<div className="erp-group">
					<ul className="erp-list">
						<li className="align-right">
							<div className="title-group">
								<strong className="title">국내 최고 전문가와 함께하는 플랫폼</strong>
								<p className="desc">
									국내 최대 회계법인, 삼일회계법인의 스타트업 <br />
									통합경영지원서비스를 스텔라를 통해 <br />
									이용할 수 있습니다.
								</p>
							</div>
						</li>
						<li className="align-left">
							<div className="title-group">
								<strong className="title">데이터 중심의 비즈니스 혁신</strong>
								<p className="desc">
									통합된 데이터 관리와 높은 활용도로 <br />
									새로운 성장 동력을 얻을 수 있습니다.
								</p>
							</div>
						</li>
						<li className="align-right">
							<div className="title-group">
								<strong className="title">사용자 친화적 경험</strong>
								<p className="desc">
									직관적 UI와 맞춤형 기능으로 <br />
									누구나 쉽고 편리하게 사용 가능합니다.
								</p>
							</div>
						</li>
						<li className="align-left">
							<div className="title-group">
								<strong className="title">혁신적인 AI 기능</strong>
								<p className="desc">
									AI 기반 자동화를 통해 데이터 활용 폭을 넓히고 <br />
									빠른 의사결정을 지원합니다.
								</p>
							</div>
						</li>
					</ul>
					<div className="erp-img">
						<span className="txt-holder">
							<p>
								STELLA <br /> <span className="font-bold">ERP</span>
							</p>
						</span>
					</div>
				</div>
			</div>
		</section>
	);
};

export default ErpBanner;
